import { dataroomApi } from './dataroomApi';

/**
 * First Label Analysis endpoints, injected into the dataroom API so the
 * generated deliverables (registered as dataroom documents) can be refreshed
 * through the same tag system when a run completes.
 */
export const firstLabelApi = dataroomApi
  .enhanceEndpoints({ addTagTypes: ['FirstLabelRun'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getFirstLabelRuns: builder.query({
        query: (projectUuid) => `/api/first-label/runs/?project=${projectUuid}`,
        // Uploading or deleting a document changes how many private documents
        // the report has not read yet, so document changes refetch the runs.
        providesTags: [{ type: 'FirstLabelRun', id: 'LIST' }, { type: 'Document', id: 'LIST' }],
      }),

      createFirstLabelRun: builder.mutation({
        query: ({ projectUuid, company }) => ({
          url: '/api/first-label/',
          method: 'POST',
          body: { project_uuid: projectUuid, company },
        }),
        invalidatesTags: [{ type: 'FirstLabelRun', id: 'LIST' }],
      }),

      // Edits the finished report from the private documents added since the
      // last update; no new public research.
      updateFirstLabelReport: builder.mutation({
        query: ({ runUuid }) => ({
          url: `/api/first-label/runs/${runUuid}/update/`,
          method: 'POST',
        }),
        invalidatesTags: [{ type: 'FirstLabelRun', id: 'LIST' }],
      }),
    }),
  });

export const {
  useGetFirstLabelRunsQuery,
  useCreateFirstLabelRunMutation,
  useUpdateFirstLabelReportMutation,
} = firstLabelApi;
